"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVatTable = exports.createTotalTable = exports.createSubtotalTable = exports.createPaymentDetails = exports.createOrderId = exports.createOrderDate = exports.createMerchantInfo = exports.createInvoiceInfo = exports.createHeaderTable = exports.createFeesTable = exports.createCustomerInfo = exports.createBodyTable = exports.createAmountInfo = void 0;

var _dateFns = require("date-fns");

var _currency = require("../../currency");

var createMerchantInfo = function createMerchantInfo(merchant, translate) {
  var _merchant$address, _merchant$address2, _merchant$address3, _merchant$address4;

  var merchantInfo = [[{
    content: merchant.name,
    styles: {
      minCellHeight: 1,
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        top: 3,
        bottom: 3
      }
    }
  }], [{
    content: (_merchant$address = merchant.address) === null || _merchant$address === void 0 ? void 0 : _merchant$address.street,
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575',
      fontSize: 9
    }
  }], [{
    content: "".concat((_merchant$address2 = merchant.address) === null || _merchant$address2 === void 0 ? void 0 : _merchant$address2.zip, " ").concat((_merchant$address3 = merchant.address) === null || _merchant$address3 === void 0 ? void 0 : _merchant$address3.city),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575',
      fontSize: 9
    }
  }], [{
    content: merchant.email,
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: {
        top: !merchant.vatId && !((_merchant$address4 = merchant.address) !== null && _merchant$address4 !== void 0 && _merchant$address4.street) ? 0 : 3
      },
      textColor: '#757575',
      fontSize: 9
    }
  }]];

  if (merchant.vatId) {
    merchantInfo.splice(3, 0, [{
      content: translate('pdf.invoice.vatID', {
        vatID: merchant.vatId
      }),
      styles: {
        halign: 'left',
        font: 'Montserrat',
        cellPadding: 0,
        textColor: '#757575',
        fontSize: 9
      }
    }]);
  }

  return merchantInfo;
};

exports.createMerchantInfo = createMerchantInfo;

var createInvoiceInfo = function createInvoiceInfo(transaction, translate) {
  return [[{
    content: translate('pdf.invoice.invoiceName'),
    styles: {
      halign: 'right',
      font: 'Montserrat',
      fontStyle: 'medium',
      cellPadding: {
        bottom: 2
      }
    }
  }], [{
    content: transaction === null || transaction === void 0 ? void 0 : transaction.number,
    styles: {
      halign: 'right',
      font: 'Montserrat',
      cellPadding: 0
    }
  }], [{
    content: translate('pdf.invoice.issuedOn'),
    styles: {
      halign: 'right',
      font: 'Montserrat',
      fontStyle: 'medium',
      cellPadding: {
        top: 4,
        bottom: 2
      },
      textColor: '#757575'
    }
  }], [{
    content: transaction.chargeDate,
    styles: {
      halign: 'right',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575'
    }
  }]];
};

exports.createInvoiceInfo = createInvoiceInfo;

var createCustomerInfo = function createCustomerInfo(customer) {
  return [[{
    content: "".concat(customer.firstName, " ").concat(customer.lastName),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      textColor: '#000000',
      cellPadding: {
        bottom: 4
      }
    }
  }], [{
    content: customer === null || customer === void 0 ? void 0 : customer.street,
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0
    }
  }], [{
    content: "".concat(customer === null || customer === void 0 ? void 0 : customer.zipCode, " ").concat(customer === null || customer === void 0 ? void 0 : customer.city),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0
    }
  }]];
};

exports.createCustomerInfo = createCustomerInfo;

var createAmountInfo = function createAmountInfo(order, translate, locale) {
  return [[{
    content: (0, _currency.getCurrencyFormat)(order.grossValue, order.currency, locale),
    styles: {
      halign: 'left',
      fontSize: 20,
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        bottom: 4
      }
    }
  }], [{
    content: translate('pdf.invoice.toPay'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575',
      fontSize: 9
    }
  }], [{
    content: translate('pdf.invoice.dueDate', {
      date: order.dueDate
    }),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        top: 3
      }
    }
  }]];
};

exports.createAmountInfo = createAmountInfo;

var createPaymentDetails = function createPaymentDetails(transaction, translate) {
  return [[{
    content: translate('pdf.invoice.paymentDetails'),
    styles: {
      halign: 'left',
      fontSize: 12,
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        bottom: 5
      }
    }
  }], [{
    content: translate('pdf.invoice.bgNumber'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        bottom: 1
      },
      fontSize: 10
    }
  }], [{
    content: transaction.bgNumber,
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0
    }
  }], [{
    content: translate('pdf.invoice.ocr'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        top: 4,
        bottom: 1
      },
      fontSize: 10
    }
  }], [{
    content: transaction.reference,
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0
    }
  }], [{
    content: translate('pdf.invoice.paymentProvider'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: {
        top: 4,
        bottom: 1
      },
      fontSize: 10,
      textColor: '#757575'
    }
  }], [{
    content: translate('pdf.invoice.originator'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575'
    }
  }]];
};

exports.createPaymentDetails = createPaymentDetails;

var getOrderID = function getOrderID(order) {
  return order.reference || order.id || '-';
};

var createOrderId = function createOrderId(order, translate) {
  return [[{
    content: translate('pdf.invoice.orderID'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        bottom: 3
      }
    }
  }], [{
    content: getOrderID(order),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575'
    }
  }]];
};

exports.createOrderId = createOrderId;

var createHeaderTable = function createHeaderTable(itemsHeader) {
  return [itemsHeader.map(function (header) {
    return {
      content: header.text,
      styles: {
        halign: header.align,
        font: 'Montserrat',
        fontStyle: 'bold',
        cellPadding: {
          top: 5,
          bottom: 8
        }
      }
    };
  })];
};

exports.createHeaderTable = createHeaderTable;

var createOrderDate = function createOrderDate(order, translate) {
  return [[{
    content: translate('pdf.invoice.orderDate'),
    styles: {
      halign: 'right',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        bottom: 3
      }
    }
  }], [{
    content: (0, _dateFns.format)(new Date(order.date), 'dd/MM/yyyy'),
    styles: {
      halign: 'right',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575'
    }
  }]];
};

exports.createOrderDate = createOrderDate;

var getItemID = function getItemID(item) {
  return item.id || item.articleId || '-';
};

var createBodyTable = function createBodyTable(items, order, locale) {
  return items.map(function (item, index) {
    var _order$fees, _order$fees2, _order$fees3, _order$fees4, _order$fees5, _order$fees6;

    return [{
      content: item.description ? item.description : '-',
      styles: {
        halign: 'left',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === items.length - 1 && ((_order$fees = order.fees) === null || _order$fees === void 0 ? void 0 : _order$fees.length) === 0 ? 7 : 4
        }
      }
    }, {
      content: getItemID(item),
      styles: {
        halign: 'center',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === items.length - 1 && ((_order$fees2 = order.fees) === null || _order$fees2 === void 0 ? void 0 : _order$fees2.length) === 0 ? 7 : 4
        }
      }
    }, {
      content: item.numberOfItems,
      styles: {
        halign: 'center',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === items.length - 1 && ((_order$fees3 = order.fees) === null || _order$fees3 === void 0 ? void 0 : _order$fees3.length) === 0 ? 7 : 4
        }
      }
    }, {
      content: (0, _currency.getCurrencyFormat)(item.itemValue, order.currency, locale),
      styles: {
        halign: 'left',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === items.length - 1 && ((_order$fees4 = order.fees) === null || _order$fees4 === void 0 ? void 0 : _order$fees4.length) === 0 ? 7 : 4
        }
      }
    }, {
      content: "".concat(parseInt(item.vatPercentage, 10), "%"),
      styles: {
        halign: 'center',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === items.length - 1 && ((_order$fees5 = order.fees) === null || _order$fees5 === void 0 ? void 0 : _order$fees5.length) === 0 ? 7 : 4
        }
      }
    }, {
      content: (0, _currency.getCurrencyFormat)(item.grossValue, order.currency, locale),
      styles: {
        halign: 'right',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === items.length - 1 && ((_order$fees6 = order.fees) === null || _order$fees6 === void 0 ? void 0 : _order$fees6.length) === 0 ? 7 : 4
        }
      }
    }];
  });
};

exports.createBodyTable = createBodyTable;

var createFeesTable = function createFeesTable(order, translate, locale) {
  var _order$fees7;

  return order === null || order === void 0 ? void 0 : (_order$fees7 = order.fees) === null || _order$fees7 === void 0 ? void 0 : _order$fees7.map(function (fee, index) {
    return [{
      content: fee.description ? fee.description : translate("pdf.invoice.fees.".concat(fee.type.toLowerCase())),
      styles: {
        halign: 'left',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.fees.length - 1 ? 7 : 4
        }
      }
    }, {
      content: fee.id ? fee.id : '-',
      styles: {
        halign: 'center',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.fees.length - 1 ? 7 : 4
        }
      }
    }, {
      content: fee.numberOfItems,
      styles: {
        halign: 'center',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.fees.length - 1 ? 7 : 4
        }
      }
    }, {
      content: (0, _currency.getCurrencyFormat)(fee.itemValue, order.currency, locale),
      styles: {
        halign: 'left',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.fees.length - 1 ? 7 : 4
        }
      }
    }, {
      content: "".concat(parseInt(fee.vatPercentage, 10), "%"),
      styles: {
        halign: 'center',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.fees.length - 1 ? 7 : 4
        }
      }
    }, {
      content: (0, _currency.getCurrencyFormat)(fee.grossValue, order.currency, locale),
      styles: {
        halign: 'right',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.fees.length - 1 ? 7 : 4
        }
      }
    }];
  });
};

exports.createFeesTable = createFeesTable;

var createSubtotalTable = function createSubtotalTable(order, translate, locale) {
  return [{
    content: '',
    styles: {
      cellWidth: 220
    }
  }, {
    content: translate('pdf.invoice.table.subTotal'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: {
        top: 4,
        bottom: 4
      }
    }
  }, {
    content: (0, _currency.getCurrencyFormat)(order.netValue, order.currency, locale),
    styles: {
      halign: 'right',
      font: 'Montserrat',
      cellPadding: {
        top: 4,
        bottom: 4
      }
    }
  }];
};

exports.createSubtotalTable = createSubtotalTable;

var createVatTable = function createVatTable(order, translate, locale) {
  return order.vat.map(function (vat, index) {
    return [{
      content: '',
      styles: {
        cellWidth: 220,
        cellPadding: {
          top: 4,
          bottom: index === order.vat.length - 1 ? 7 : 4
        }
      }
    }, {
      content: translate('pdf.invoice.table.vat'),
      styles: {
        halign: 'left',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.vat.length - 1 ? 7 : 4
        }
      }
    }, {
      content: (0, _currency.getCurrencyFormat)(vat.value, order.currency, locale),
      styles: {
        halign: 'right',
        font: 'Montserrat',
        cellPadding: {
          top: 4,
          bottom: index === order.vat.length - 1 ? 7 : 4
        }
      }
    }];
  });
};

exports.createVatTable = createVatTable;

var createTotalTable = function createTotalTable(order, translate, locale) {
  return [[{
    content: '',
    styles: {
      cellWidth: 220,
      cellPadding: {
        top: 7
      }
    }
  }, {
    content: translate('pdf.invoice.table.total'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        top: 7
      },
      fontSize: 10
    }
  }, {
    content: (0, _currency.getCurrencyFormat)(order.grossValue, order.currency, locale),
    styles: {
      halign: 'right',
      font: 'Montserrat',
      fontStyle: 'bold',
      cellPadding: {
        top: 7
      },
      fontSize: 10
    }
  }], [{
    content: '',
    styles: {
      cellWidth: 220,
      cellPadding: 0
    }
  }, {
    content: translate('pdf.invoice.table.vatInc'),
    styles: {
      halign: 'left',
      font: 'Montserrat',
      cellPadding: 0,
      textColor: '#757575'
    }
  }, {
    content: '',
    styles: {
      cellPadding: 0
    }
  }]];
};

exports.createTotalTable = createTotalTable;